<template>
  <div class="tw:text-sm tw:text-gray-800 tw:bg-orange-200 tw:rounded-lg tw:px-5 tw:py-4">
    <p
      class="notification tw:inline tw:mr-[0.25em]"
      v-html="
        type === 'RATE_CONNECT'
          ? $t('rc_fop_expiring_info', {
              ExpirationDate: formatDate(cardExpirationDate),
            })
          : $t('plus_fop_expiring_info', {
              ExpirationDate: formatDate(cardExpirationDate),
            })
      "
    />
    <i18n-t keypath="fop_hotelier_support" tag="p" class="tw:inline expired-note">
      <template #HotelierSupport>
        <button
          @click="handleRedirection"
          class="tw:text-gray-800 tw:hover:text-blue-800 tw:cursor-pointer tw:underline tw:text-[revert]"
        >
          {{ $t('hotelier_support_team') }}
        </button>
      </template>
    </i18n-t>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import { selectedAccommodationId } from '@/layouts/queries'
import { getContactUrl } from '@/utils/Utility.ts'
import { useSessionValues } from '@/composables/useSessionValues'

import appAnalytics from '@/utils/tracking'
import { useFormatting } from '@/composables/useFormatting'

const props = defineProps({
  defaultPaymentMethod: Object,
  cardExpirationDate: Date,
  type: String,
})

const { formatDate } = useFormatting()
const { language, userId } = useSessionValues()
const contactUrl = computed(() => getContactUrl(language.value, userId.value, selectedAccommodationId.value, true))

const handleRedirection = () => {
  appAnalytics.track(appAnalytics.events.RC_RESUME_CAMPAIGN_HOTELIER_SUPPORT_CLICKED, {
    accommodationId: selectedAccommodationId.value,
    paymentMethod: props.defaultPaymentMethod?.type,
    isExpired: false,
    expirationDate: `${props.defaultPaymentMethod?.expirationMonth}/${props.defaultPaymentMethod?.expirationYear}`,
  })

  window.open(contactUrl.value, '_blank', 'noopener,noreferrer')
}
</script>
<style scoped>
.notification :deep(span) {
  font-weight: bold;
}
</style>
